<script setup>
import { computed } from 'vue'
import Icon from '@/Components/UI/Icon.vue'

const props = defineProps({
  modelValue: { type: [String, Number], default: '' },
  type:      { type: String, default: 'text' },
  placeholder: { type: String, default: '' },
  error:     { type: String, default: '' },
  hint:      { type: String, default: '' },
  iconLeft:  { type: String, default: '' },
  disabled:  { type: Boolean, default: false },
  id:        { type: String, default: '' },
})
defineEmits(['update:modelValue'])
const hasError = computed(() => !!props.error)
</script>

<template>
  <div class="flex flex-col gap-1">
    <div class="relative">
      <Icon
        v-if="iconLeft"
        :name="iconLeft"
        :size="16"
        class="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--muted)] pointer-events-none"
      />
      <input
        :id="id"
        :type="type"
        :value="modelValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :aria-invalid="hasError || undefined"
        :aria-describedby="hasError ? `${id}-err` : undefined"
        :class="[
          'w-full h-9 text-sm bg-[color:var(--surface)] text-[color:var(--ink)]',
          'rounded-[var(--radius-input)] border transition-colors',
          'focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--accent)]',
          hasError ? 'border-[color:var(--danger)]' : 'border-[color:var(--line)] focus:border-[color:var(--accent)]',
          iconLeft ? 'pl-9 pr-3' : 'px-3',
          disabled && 'opacity-50 cursor-not-allowed',
        ]"
        @input="$emit('update:modelValue', $event.target.value)"
      />
    </div>
    <p v-if="hasError" :id="`${id}-err`" class="text-xs text-[color:var(--danger)]">{{ error }}</p>
    <p v-else-if="hint" class="text-xs text-[color:var(--muted)]">{{ hint }}</p>
  </div>
</template>
